// eslint-disable-next-line import/named
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'CContentItem',
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        },
        src: {
            type: String,
            required: false,
            default: ''
        }
    }
});
